import React from 'react';
import CustomLoading from 'components/custom-loading/custom-loading';

export default function Spinner() {
  return <CustomLoading />;
}
